<template>
  <q-row
    :gutter="10"
    class="dashboard-container"
  >
    <q-header />
    <component :is="getLeftColumn" />
    <component :is="getRightColumn" />
  </q-row>
</template>

<script>
  import header from './header';
  import config from '../../q-components/q-config';
  import asideContainer from "./dashboardContainer/asideContainer";
  import mainContainer from "./dashboardContainer/mainContainer";

  export default {
    name: "Dashboard",

    components: {
      'q-header': header,
      'q-aside-container': asideContainer,
      'q-main-container': mainContainer,
    },

    mixins: [config],

    computed: {
      isRtl() {
        return this.$qt('direction') === 'rtl';
      },
      getRightColumn() {
        return this.isRtl ? 'q-aside-container' : 'q-main-container'
      },
      getLeftColumn() {
        return this.isRtl ? 'q-main-container' : 'q-aside-container'
      }
    },
  };
</script>

<style scoped>
    .dashboard-container {
        padding: 20px;
    }
</style>